<template>
  <b-navbar id="navbar-main" toggleable="sm" type="dark">
    <div class="container-fluid">
      <div class="navbar-header">
        <router-link :to="{ name: 'home' }">
          <b-navbar-brand>
            <span class="text-hide">Your Pass Now</span>
          </b-navbar-brand>
        </router-link>
      </div>
      <b-collapse is-nav id="navbar-collapse" right>
        <b-navbar-nav class="ml-auto">
          <b-nav-item :href="baseUrl + '#destinations'" right
            >Destinations</b-nav-item
          >
        </b-navbar-nav>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
export default {
  computed: {
    baseUrl() {
      return process.env.BASE_URL;
    }
  }
};
</script>
